import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api/client.js";
import type { Ruolo } from "@taras/contracts";

interface MeResponse {
  id: string;
  username: string;
  nome: string;
  cognome: string;
  ruolo: Ruolo;
  must_change_password: boolean;
  mfa_enabled: boolean;
}

export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ["auth", "me"],
    queryFn: () => apiClient.get<MeResponse>("/api/v1/auth/me"),
    retry: false,
  });
}
